
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Cell, Duty, DutyClient } from '../../../../backend/backendapi';
import { VueGoodTable } from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css';
import { WindowType } from '../../../../../util';
import { initClient } from '../../../../../api';
import { paginationOptions, searchOptions } from '../../../../../util/vue-good-table';

declare var window: WindowType;

@Component({
  components: {
    VueGoodTable,
  },
})
export default class TabDuties extends Vue {
  @Prop({ required: true })
  readonly cell!: Cell;

  //api
  dutyApi = initClient(DutyClient);

  //runtime
  readonly duties: Duty[] = [];

  get cellDuties(): Duty[] {
    if (!this.cell?.id) {
      return [];
    }
    return this.duties.filter(d => d.cells?.some(m => m.cellId === this.cell!.id));
  }

  get columnsConfig(): unknown[] {
    return [
      {
        label: 'Name',
        field: (e: Duty) => e.title,
      },
      {
        label: 'Zelle',
        field: (e: Duty) => e.cell,
      },
      {
        label: 'Label',
        field: (e: Duty) => e.label,
      },
      {
        label: 'D',
        field: (d: Duty) => d.isDisabled ? 'D' : '',
      },
      {
        label: '',
        field: 'actions',
      },
    ];
  }

  get paginationOptions(): any {
    return paginationOptions(this.$i18n);
  }

  get searchOptions(): any {
    return searchOptions(this.$i18n);
  }

  async mounted(): Promise<void> {
    await this.reloadAll();
  }

  reloadAll(): Promise<void> {
    return this.reloadDuties();
  }

  async reloadDuties(): Promise<void> {
    let duties = (await this.dutyApi.getDutiesData()).duties;
    this.duties.splice(0);
    this.duties.push(...duties);
  }

  gotoDuty(duty: Duty): void {
    window.location.href = 'quick?duty=' + duty.dutyId;//TODO this is bad, what if the component is mounted somewhere else?
  }

  gotoNewDuty(): void {
    window.location.href = 'quick?duty&action=new&cells=' + this.cell.id;//TODO this is bad, what if the component is mounted somewhere else?
  }
}
